import React, { FC } from 'react'
import { matchPath } from 'react-router-dom'

import List from '@material-ui/core/List'

import NavigationListItem from '../../Molecules/NavigationListItem/NavigationListItem'
import useRouter from '../../../helpers/useRouter'
import { hasAccess } from '../../../helpers/functions/hasAccess'
import { NavigationConfig } from '../../../interfaces/NavigationConfig'
import { NavItem } from '../../../interfaces/NavItem'

interface Props {
    page: NavigationConfig
    depth?: number
    onClose?: () => void
}

const NavigationList: FC<Props> = ({ page, depth = 0, onClose = undefined }) => {
    const router = useRouter()

    const open = matchPath(router && router.location && router.location.pathname, {
        path: page && page.href,
        exact: false,
        strict: false,
    })

    let navItemListProps: NavItem = {
        depth,
        icon: page && page.icon,
        key: page && page.title,
        label: page && page.label,
        title: page && page.title,
    }

    if (page && page.children) {
        navItemListProps = { ...navItemListProps, open: page && page.children && Boolean(open) }
    } else {
        navItemListProps = { ...navItemListProps, href: page && !page.children && page.href, onClose }
    }

    return (
        <List>
            <NavigationListItem {...navItemListProps}>
                {page &&
                    page.children &&
                    page.children
                        .filter((p) => hasAccess(p))
                        .map((element) => (
                            <NavigationList depth={depth + 1} key={element.title} onClose={onClose} page={element} />
                        ))}
            </NavigationListItem>
        </List>
    )
}

export default NavigationList
